<template>
  <v-card >
    <v-card-title style="line-height: 1.4;margin: 0;color: #6a6a6a;font-size:24px;display: flex; flex-direction: row; align-items: start;">
      <v-select
        :items="filterRmbox"
        label="Rmbox"
        item-text="text"
        item-value="value"
        v-on:change="selectRmboxMenu"
        v-model="type"
        v-if="byType"
        solo
      ></v-select>
      <v-spacer></v-spacer>
      <v-select
        :items="filterState"
        label="Etats"
        v-on:change="selectStateMenu"
        v-model="state"
        v-if="byStatus"
        solo
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Recherche"
        single-line
        v-if="byWord"
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="true"
      :no-data-text="no_data_text"
      :no-results-text="no_data_text"
      :rows-per-page-text="rows"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :rows-per-page-items="rows_per_page"
      :class="id"
    >
      <v-progress-linear :active="loading" slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td v-for="(header,index) in headers" :key="index" :class="props.item[header.id]">
            <div v-html="props.item[header.value]"></div>
        </td>
      </template>
      <template slot="no-data" v-if="!loading">
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import {HTTP} from '../core/http/http-common';
  import Routing from '../core/router/router';
    export default {
        name: "tab-content-intervention",
      props: {
        headers: {
          type: Array,
          required: true
        },
        filterList: {
          type: Array,
          required: true
        },
        sorting:{
          type: Object,
          required: true
        },
        api : {
          type: String,
          required : true
        },
        defaultType : {
          type: String,
          default : ''
        },
          idRmbox:null
      },
      data() {
        return {
          search : '',
          draw : 0,
          rows: "Lignes par page",
          rows_per_page : [5,10,20,25,{"text":"Tous","value":-1}],
          filterRmbox: [{
            value : 'display',
            text : 'screenBox'
          }, {
            value : 'non-display',
            text : 'Rmbox'
          }],
          filterState: [
            {
              value : '',
              text : 'Tous les états'
            },
            {
              value : 'OK',
              text : 'OK'
            },
            {
              value : 'SAUF-OK',
              text : 'SAUF-OK'
            },
            {
              value : 'CRITICAL',
              text : 'CRITICAL'
            },
            {
              value : 'SEEK - UNREACHABLE',
              text : 'SEEK - UNREACHABLE'
            }],
          no_data_text : 'Pas de donnée',
          pagination: {
            rowsPerPage : 10
          },
          loading : true,
          items : [],
          totalItems : 0,
          type : '',
          state : '',
          byType : true,
          byWord : true,
          byStatus : true
        }
        },
      watch: {
        pagination: {
          handler (object) {
            this.query.type = this.type;
            this.query.status = this.state;
            this.query.length = object.rowsPerPage;
            this.query.start = object.rowsPerPage*(object.page - 1);
            this.query.columns = [];
            this.query.columns[this.sorting[object.sortBy]] = {};
            this.query.columns[this.sorting[object.sortBy]].orderable = true;
            this.query.order = [];
            this.query.order[0] = {};
            this.query.order[0].column = this.sorting[object.sortBy];
            if(object.descending) {
              this.query.order[0].dir = "desc"
            }else{
              this.query.order[0].dir = "asc"
            }
            this.getData();
          },
          deep: true
        },
        search:{
          handler(object){
            if(object === ''){
              this.query.search = {};
            }else{
              this.query.search.value = object;
            }
            this.getData();
          }
          }
        },
      methods : {
        selectRmboxMenu(value){
          this.query.type = value;
          this.getData()
        },
        selectStateMenu(value){
          this.query.status = value;
          this.getData()
        },
        getData(){
          let self= this;
          self.loading = true;
          this.query.draw++;
          HTTP.get(Routing.generate(this.api, this.query))
            .then(function(response){

              if(response.data.code === 200){
                self.$nextTick(function(){
                  self.loading = false;
                  self.items = response.data.data;
                  self.totalItems = response.data.recordsFiltered;
                })
              }
              else{
                self.loading = false;
              }
            },function(error){
              console.log(error)
              self.loading = false;

            })
        }
      },
      created(){
        this.query = {
          length: 10,
          start: 0,
          draw : 0
        };
        if(this.idRmbox){
            this.query.idRmbox=this.idRmbox;
        }
        this.query.type = '';
        this.query.status = '';
        this.query.columns = [];
        this.query.columns[0] = {};
        this.query.columns[0].orderable = true;
        this.query.order = [];
        this.query.order[0] = {};
        this.query.order[0].column = 0;
        this.query.order[0].dir = 'asc';
        this.query.search = {};
        // document.addEventListener('click',function(){
        //
        //   const menu = document.querySelectorAll('.v-menu__content');
        //   menu.forEach(function(item){
        //     document.getElementById('wrapper').insertBefore(item, document.getElementById('wrapper').childNodes[0]);
        //
        //   });
        // })
      },
      mounted(){
        this.type = this.defaultType;
        this.query.type = this.type;
//        this.getData();
        const menu = document.querySelectorAll('.v-menu__content');
          menu.forEach(function(item){
            document.getElementById('wrapper').insertBefore(item, document.getElementById('wrapper').childNodes[0]);
          })
        var self = this;
        this.filterList.forEach(function(item){
          var keys = Object.keys(item);
          self[keys[0]] = item[keys[0]];
        })
      }
    }
</script>

<style scoped>

#status td{
    text-align: center;
}
.OK div, .CRITICAL div, .SEEK-UNREACHABLE div{
    color: #fff;
    width: 165px;
    margin: 0 auto;
    padding:10px;
    }
.OK div{
    background: #5eba7d;
    }
.CRITICAL div{
    background: #e64320;
    }
.SEEK-UNREACHABLE div{
    background: #000000;
    }
</style>



// WEBPACK FOOTER //
// src/components/tabContentIntervention.vue